document.addEventListener('DOMContentLoaded', function () {
  const bannerGroups = document.querySelectorAll('.p-wrap__banner--box');
  const windowHeight = window.innerHeight;

  // 背景画像のURLを設定
  const backgroundImages = [
    'url(path/to/your/first/image.jpg)', // 1つ目の背景画像
    'url(path/to/your/second/image.jpg)' // 2つ目の背景画像
  ];

  window.addEventListener('scroll', function () {
    bannerGroups.forEach((group, index) => {
      const groupRect = group.getBoundingClientRect();
      const groupCenter = groupRect.top + groupRect.height / 2;

      // 要素の中心が画面の中心に近いかチェック
      if (groupCenter > windowHeight * 0 && groupCenter < windowHeight * 1) {
        // 背景を固定して画像を設定
        // document.body.style.backgroundImage = backgroundImages[index % backgroundImages.length];
        // document.body.style.backgroundAttachment = 'fixed';
        group.classList.add('active');
      } else {
        group.classList.remove('active');
      }
    });
  });
});